export const ALLUMNI=[
  {
    "displayText": "ALUMNI ASSOCIATION REGISTRATION CERTIFICATE",
    "filename": "./assets/documentation/alumni/ALUMNI ASSOCIATION REGISTRATION CERTIFICATE.pdf",
    "link": ""
  }
]